import * as Sentry from "@sentry/minimal";
import debug from "debug";
debug.formatters.d = (v) => {
    return new Date(v).toLocaleString();
};
const error = debug("ERROR");
const warn = debug("WARN");
const info = debug("INFO");
const dev = debug("DEV");
const request = debug("REQUEST");
const parcel = debug("PARCEL");
const print = debug("PRINT");
export const logger = {
    captureWarning: (message, e) => {
        warn(message || "", e);
        if (message) {
            Sentry.captureMessage(message);
        }
    },
    captureException: (e, message) => {
        error(message || "", e);
        // const errorString = _isObject(e) ? JSON.stringify(e, null, 2) : e.toString();
        // Sentry.captureMessage(errorString);
        Sentry.captureException(e);
    },
    error: error,
    warn: warn,
    info: info,
    dev: dev,
    request: request,
    parcel: parcel,
    print: print,
};
//# sourceMappingURL=index.js.map